import React, { memo } from 'react'

import { func, number, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import OptionGroup from './Components/OptionGroup/OptionGroup'
import { ASPECT_RATIOS, VARIATION_COUNTS } from './settingsOptions'

const ratioModifier = ratio => ratio.replace(':', '-')

const ASPECT_RATIO_OPTIONS = ASPECT_RATIOS.map(ratio => ({
  value: ratio,
  label: ratio,
  icon: (
    <span
      className={`generation-settings__ratio generation-settings__ratio--${ratioModifier(ratio)}`}
      aria-hidden="true"
    />
  ),
}))

const VARIATION_OPTIONS = VARIATION_COUNTS.map(count => ({
  value: count,
  label: String(count),
  icon: (
    <span className="generation-settings__grid" aria-hidden="true">
      {VARIATION_COUNTS.map(cell => (
        <span
          key={cell}
          className={`generation-settings__grid-cell${cell <= count ? ' generation-settings__grid-cell--filled' : ''}`}
        />
      ))}
    </span>
  ),
}))

function SettingsPanel({ settings, onChange }) {
  const t = useTranslation()
  const label = key => t(`imageAssistantPanel.createTab.composer.settings.${key}`)

  return (
    <div className="generation-settings__panel" role="dialog" aria-label={label('trigger')}>
      <OptionGroup
        id="generation-settings-aspect-ratio"
        label={label('aspectRatio')}
        options={ASPECT_RATIO_OPTIONS}
        value={settings.aspectRatio}
        onChange={value => onChange('aspectRatio', value)}
      />
      <OptionGroup
        id="generation-settings-variations"
        label={label('variations')}
        options={VARIATION_OPTIONS}
        value={settings.variations}
        onChange={value => onChange('variations', value)}
      />
    </div>
  )
}

SettingsPanel.propTypes = {
  settings: shape({
    aspectRatio: string.isRequired,
    variations: number.isRequired,
  }).isRequired,
  onChange: func.isRequired,
}

export default memo(SettingsPanel)
